import { render } from "./SecondCarouselItem.vue?vue&type=template&id=ffae8c20&scoped=true"
import script from "./SecondCarouselItem.vue?vue&type=script&lang=js"
export * from "./SecondCarouselItem.vue?vue&type=script&lang=js"

import "./SecondCarouselItem.vue?vue&type=style&index=0&id=ffae8c20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffae8c20"]])

export default __exports__